'use client'


import { MInput } from '@/_components/medante/m-input'

import { ERR } from '../_utils/patient-form.constants'

import { APatientInfoSectionHeading } from './a-patient-info-section-heading'

import type { PatientFormValues } from '../_types/patient-form.types'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'

type APatientInfoAddressSectionProps = {
	register: UseFormRegister<PatientFormValues>
	errors: FieldErrors<PatientFormValues>
}

export function APatientInfoAddressSection({ register, errors }: APatientInfoAddressSectionProps) {
	return (
		<section className='mb-8'>
			<APatientInfoSectionHeading>Adresa pacienta</APatientInfoSectionHeading>

			<div className='grid grid-cols-1 gap-2.5 md:grid-cols-3 md:gap-4'>
				<MInput
					label='Adresa'
					required
					error={errors.address?.message}
					registration={register('address', { required: ERR.address })}
				/>

				<MInput
					label='Mesto'
					required
					error={errors.city?.message}
					registration={register('city', { required: ERR.city })}
				/>

				<MInput
					label='PSČ'
					required
					error={errors.zipCode?.message}
					registration={register('zipCode', {
						required: ERR.zipCode.required,
						pattern: {
							value: /^\d{3}\s?\d{2}$/,
							message: ERR.zipCode.invalid
						}
					})}
				/>
			</div>
		</section>
	)
}
